import { OrderStatuses } from '@insurance/types'
import { SelectProps } from 'antd'
import { TFunction } from 'i18next'

export const statusList = [...Object.values(OrderStatuses)] as const

export const statusOptions = (t: TFunction): SelectProps['options'] =>
  statusList
    .map((value) => ({
      label: t(value),
      value
    }))
    .sort((a, b) => String(a.label).localeCompare(String(b.label)))
